import { useRef } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CustomInputField from "../../../../../../CustomHTMLElements/CustomInputField";
import { GetStartedSteps } from "../../types";
import styles from "./PersonalInformation.module.scss";

const schema = yup.object().shape({
  email: yup
    .string()
    .email("Please enter a valid email")
    .required("Please enter email address"),
  phoneNumber: yup
    .string()
    .required("Please enter phone number")
    .matches(/^\d+$/, "Must contain only numbers"),
  firstname: yup.string().required("Please enter first name"),
  lastname: yup.string().required("Please enter last name"),
});

type FormData = {
  email: string;
  phoneNumber: string;
  firstname: string;
  lastname: string;
};

interface IPersonalInformation {
  handleNextStep: (step: GetStartedSteps, data: any) => void;
  defaultValues?: Partial<FormData>;
}

const PersonalInformation: React.FC<IPersonalInformation> = ({
  handleNextStep,
  defaultValues = {},
}) => {
  const formRef = useRef<HTMLFormElement>(null);

  const { register, handleSubmit, errors } = useForm<FormData>({
    resolver: yupResolver(schema),
    defaultValues: {
      firstname: defaultValues.firstname || "",
      lastname: defaultValues.lastname || "",
      phoneNumber: defaultValues.phoneNumber || "",
      email: defaultValues.email || "",
    },
  });

  const onSubmit = (values: FormData) => {
    handleNextStep(GetStartedSteps.VERIFY_BUSINESS, {
      ...values,
      countryCode: "NG", // Default to Nigeria
      phoneNoCountryDialCode: "+234",
    });
  };

  const handleProceedClick = () => {
    if (formRef.current) {
      formRef.current.requestSubmit();
    }
  };

  return (
    <form
      ref={formRef}
      onSubmit={handleSubmit(onSubmit)}
      className={styles.form}
    >
      <div className="row mt-4">
        <div className="col-12">
          <CustomInputField
            type="text"
            label="First Name"
            name="firstname"
            reference={register}
            placeholder="John"
            errors={errors?.firstname}
            maxLength={128}
            readOnly={!!defaultValues.firstname}
          />
        </div>
        <div className="col-12">
          <CustomInputField
            type="text"
            label="Last Name"
            name="lastname"
            reference={register}
            placeholder="Doe"
            errors={errors?.lastname}
            maxLength={128}
            readOnly={!!defaultValues.lastname}
          />
        </div>
        <div className="col-12">
          <CustomInputField
            type="text"
            label="Phone Number"
            name="phoneNumber"
            reference={register}
            placeholder="08012345678"
            errors={errors?.phoneNumber}
            maxLength={20}
          />
        </div>
        <div className="col-12">
          <CustomInputField
            type="email"
            label="Business Email"
            name="email"
            reference={register}
            placeholder="john.doe@example.com"
            errors={errors?.email}
            maxLength={128}
          />
        </div>
      </div>

      <div className={styles.actionButtonContainer}>
        <button
          type="button"
          onClick={handleProceedClick}
          className="btn advancly-btn btn-lg btn-block"
        >
          Proceed
        </button>
      </div>
    </form>
  );
};

export default PersonalInformation;
